import React from 'react'
import { Button, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TextField, Dialog, AppBar } from '@material-ui/core'
import { useEffect } from 'react'
import { Edit, Search, Close } from '@material-ui/icons'
import queryparse from 'querystring'
import { useHistory } from 'react-router-dom'
export default function Gifts({ api }) {
    const [search, setSearch] = React.useState('')
    const [gifts, setGifts] = React.useState([])
    const [count, setCount] = React.useState(0)
    const [giftName, setGiftName] = React.useState('')
    const [giftType, setGiftType] = React.useState(0)
    const [giftPrice, setGiftPrice] = React.useState(1)
    const [showDialog, setShowDialog] = React.useState(false)
    const [id, setId] = React.useState('')
    const [type, setType] = React.useState(0)
    const pointer = Number(queryparse.parse(window.location.search)["?skip"] || 0)
    const history = useHistory()
    useEffect(() => {
        api.axios.get("gifts" + window.location.search)
            .then(({ count, gifts }) => {
                setCount(count)
                setGifts(gifts);
            })
            .catch(e => console.log(e))

    }, [])
    return (
        <div>
            <Dialog open={showDialog} fullScreen={true}>
                <AppBar style={{ padding: 15 }}>Gift {type === 0 ? 'Add' : 'Edit'}</AppBar>
                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 65, marginLeft: 10, marginRight: 10 }}>
                    <TextField value={giftName} onChange={e => setGiftName(e.target.value)} variant="outlined" fullWidth label="Gift name" />
                    <br />
                    <TextField value={giftPrice} onChange={e => setGiftPrice(e.target.value)} variant="outlined" fullWidth type="number" label="Gift Price" />
                    <br />
                    <select style={{ padding: 7 }} value={giftType} onChange={e => setGiftType(e.target.value)}>
                        <option value="0">Normal</option>
                        <option value="1">Purple</option>
                        <option value="2">Pink</option>
                    </select>
                    <br />
                    <div>
                        <Button
                            disabled={giftName.trim().length === 0 || giftPrice < 1}
                            onClick={e => {
                                api.axios.post(type === 0 ? 'gifts/add' : 'gifts/edit/' + id, {
                                    giftType,
                                    giftName,
                                    giftPrice
                                })
                                    .then(d => {
                                        api.showSnack(`Gift ${type === 0 ? 'added' : 'edited'} successfully.`, 'success')
                                        var removed = gifts.filter(x => x._id !== d._id);
                                        setGifts([d, ...removed])
                                        setShowDialog(false)
                                    })
                                    .catch(e => api.showSnack(e.error || 'Something went wrong.'))

                            }} variant="outlined" color="primary">Save</Button>
                        &nbsp;&nbsp;
                        <Button onClick={e => setShowDialog(false)} variant="outlined" color="secondary">Cancel</Button>

                    </div>

                </div>
            </Dialog>
            <div style={{ display: 'flex', flexDirection: 'row-reverse', margin: 10 }}>
                <Button onClick={e => {
                    setType(0)
                    setShowDialog(true)
                }} variant="outlined" color="primary">Add Gift</Button>
                &nbsp; &nbsp;
                {window.location.search !== "" && <IconButton><Close onClick={e => window.location = "?"} /></IconButton>}
                <IconButton><Search onClick={e => window.location = "?search=" + search} /></IconButton>
                <TextField value={search} onChange={e => setSearch(e.target.value)} label="Search" />

            </div>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Gift Icon</TableCell>
                        <TableCell>Gift Name</TableCell>
                        <TableCell>Gift Price</TableCell>
                        <TableCell>ACTIONS</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {gifts.map(s => <TableRow key={s._id}>
                        <TableCell><img src={s.image} alt="hola" /></TableCell>
                        <TableCell>{s.name}</TableCell>
                        <TableCell>{s.price}</TableCell>
                        <TableCell>
                            <IconButton onClick={e => {
                                setId(s._id)
                                setGiftName(s.name)
                                setGiftType(s.type)
                                setGiftPrice(s.price)
                                setType(1)
                                setShowDialog(true)
                            }}><Edit /></IconButton>
                        </TableCell>

                    </TableRow>)}
                </TableBody>
                <div style={{ margin: 10, display: 'flex', justifyContent: 'center' }}>
                    {pointer > 19 && <Button onClick={e => window.location = ("?skip=" + (pointer - 20))}>Previous Page</Button>}
                    {pointer + 20 < count && <Button onClick={e => window.location = ("?skip=" + (pointer + 20))}> Next Page</Button>}
                </div>
            </Table>
        </div >
    )
}
